/***
 *
 * This library is used to query the Career Center JobLists from our API server.
 * API docs: ...
 *
 * Uses the following libraries:
 * - react-query (useQuery hook):
 *
 */

import { useQuery } from "react-query";
import React, { useState, useEffect } from "react";

// import our utility functions for working with filters and languages
import { i18n } from "./i18n";

const attributesToFilters = (attributes) => {
    return attributes;
};

/**
 *
 */
const loadFilters = (baseUrl, language = "de") => {
    return useQuery(["attributes"], () => {
        return fetch(`${baseUrl}/attributes?lang=${language}&returnValuesAsArray=1`)
            .then((res) => {
                if (!res.ok) {
                    console.log("Error fetching Filter attributes from ", res.url);
                    return Promise.reject(res);
                }
                console.log("Fetched attributes from ", res.url);
                return res.json();
            })
            .then((data) => {
                let filters = attributesToFilters(data);
                console.log("loaded filters", filters);
                return filters;
            });
    });
};

const loadJobs = (jobListFetchUrl, setTotalJobs) => {
    return useQuery(["joblist", jobListFetchUrl], () =>
        fetch(jobListFetchUrl)
            .then((res) => {
                if (!res.ok) {
                    console.log("Error fetching jobs from ", jobListFetchUrl);
                    return Promise.reject(res);
                }
                console.log("Fetched jobs from ", jobListFetchUrl);
                return res.json();
            })
            .then((data) => {
                console.log("received job list from server: ", data);
                console.log("total jobs: ", data.total);

                return data;
            })
    );
};

export { loadFilters, loadJobs };